<template>
  <tr>
    <td class="ta_c fst"><a :href="`kwtp://uscode=${item.kwSymbol}`">{{item.symbol}}</a></td>
    <td>{{item.kwName}}</td>
    <td class="ta_c">{{item.fqDate}}/{{item.fiscalFlag}}</td>
    <td class="ta_r">{{item.eps}}</td>
    <td class="ta_r">{{item.consensus}}</td>
    <td class="ta_r">{{item.surpValue}}</td>
    <td class="ta_c">{{item.filingDate}}</td>
    <td class="ta_c">{{item.passDay}}</td>
    <template v-if="item.tvo !== null">
      <td class="ta_r">{{item.tvo.before1yRate}}</td>
      <td class="ta_r lst">{{item.tvo.consenRatio}}</td>
    </template>
    <template v-else>
      <td class="ta_r"> - </td>
      <td class="ta_r lst"> - </td>
    </template>
  </tr>
</template>

<script>
export default {
  props: {
    item: Object
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/kiwoom/usRecord/pc/Brecord_sub.vue